 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import XHTML00_COVER from '@/components/xhtml/00_Cover'
 import XHTML03_COPYRIGHT from '@/components/xhtml/03_Copyright'
 import XHTML02_TITLE_PAGE from '@/components/xhtml/02_Title_Page'
 import XHTML01_SERIES_PAGE from '@/components/xhtml/01_Series_Page'
 import XHTML04_CONTENTS from '@/components/xhtml/04_Contents'
 import XHTML05_ACKNOWLEDGMENTS from '@/components/xhtml/05_Acknowledgments'
 import XHTML06_INTRODUCTION__THE_WRITER_S_DIET from '@/components/xhtml/06_Introduction__The_Writer_s_Diet'
 import XHTML07_1__VERBAL_VERVE from '@/components/xhtml/07_1__Verbal_verve'
 import XHTML08_2__NOUN_DENSITY from '@/components/xhtml/08_2__Noun_density'
 import XHTML09_3__PREPOSITIONAL_PODGE from '@/components/xhtml/09_3__Prepositional_podge'
 import XHTML10_4__AD_DICTIONS from '@/components/xhtml/10_4__Ad_dictions'
 import XHTML11_5__WASTE_WORDS from '@/components/xhtml/11_5__Waste_words'
 import XHTML12_AFTERWORD__HEALTHY_WRITING from '@/components/xhtml/12_Afterword__Healthy_writing'
 import XHTML13_APPENDIX__THE_WRITERSDIET_TEST from '@/components/xhtml/13_Appendix__The_WritersDiet_Test'
 import XHTML14_REFERENCES from '@/components/xhtml/14_References'
 import XHTML15_INDEX from '@/components/xhtml/15_Index'
 import XHTML16_ABOUT_THE__AUTHOR from '@/components/xhtml/16_About_the__Author'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/xhtml/04_Contents",
 			"name" : "xhtml/04_Contents",
 			"component" : XHTML04_CONTENTS
 		},
 		{
 			"path" : "/xhtml/05_Acknowledgments",
 			"name" : "xhtml/05_Acknowledgments",
 			"component" : XHTML05_ACKNOWLEDGMENTS
 		},
 		{
 			"path" : "/xhtml/06_Introduction__The_Writer_s_Diet",
 			"name" : "xhtml/06_Introduction__The_Writer_s_Diet",
 			"component" : XHTML06_INTRODUCTION__THE_WRITER_S_DIET
 		},
 		{
 			"path" : "/xhtml/07_1__Verbal_verve",
 			"name" : "xhtml/07_1__Verbal_verve",
 			"component" : XHTML07_1__VERBAL_VERVE
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js